/**
 * TagListContainer
 * --
 */
import React from 'react';
import TagListPresenter from './TagListPresenter';

const TagListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <TagListPresenter />
    </>
  );
};

export default TagListContainer;
